import Effects from './Effects.js';

import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {AbstractAudioParamParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {decibelsToLinear, linearToDecibels} from 'utils/db.js';

const SIZE = 65536;
let curve = new Float32Array(SIZE);

class Diode extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Diode', () => new Tone.WaveShaper([-1, 1]), sequencerEngine); 

        this.vb = 0.2;
        this.vl = 0.4;
        
        this.distortionParameter = new AbstractParameter(
            'distortion', this, (obj, drive) => {
                this.recomputeCurve();
            },
            {
                documention: "Controls the level of saturation.",
                min: 2,
                max: 10,
                unit: '',
                defaultValue: 0.1,
                constantAutomationRate: true
            });
        this.registerParameter(this.distortionParameter);
   }

    get distortion() {
        return this.distortionParameter ? this.distortionParameter.get() : 1;
    }

    recomputeCurve( ){
        let samples = 1024;
        let wsCurve = new Float32Array(samples);

        for (let i=0; i < samples; i++) {
            let v = (i - samples/2) / (samples/2);
            v = Math.abs(v);

            let value = 0;
            if (v <= this.vb) {
                value = 0;
            }else if ((this.vb < v) && (v <= this.vl)) {
                value = this.distortion * ((Math.pow(v - this.vb, 2)) / (2 * this.vl - 2 * this.vb));
            } else {
                value = this.distortion * v - this.distortion * this.vl + (this.distortion * ((Math.pow(this.vl - this.vb, 2)) / (2 * this.vl - 2 * this.vb)));
            }
            
            wsCurve[i] = value;
        }
        
        this.effectNode.curve = wsCurve;
    }
    
    get documentation() {
        return "Saturates the sound, making it more distorted.";
    }

    getJson() {
        let json = {
            ... super.getJson(),
            distortionParameter: this.distortionParameter.get()
        };

        json = this.saveParameterToJson(json, "distortion", this.distortionParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        bulkUpdate(this.distortionParameter, json.distortion, bulk);
        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'distortionParameter', this.distortionParamet, isCopy)
        };
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new Diode(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default Diode;
